import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { testJson } from "../modal/testModals";

function Tests(props) {
  const [checkk, setCheckk] = useState([]);
  const handleChange = (e) => {
    let { value, checked } = e.target;
    let tempcheck = checkk;
    if (checked) {
      tempcheck.push({ name: value });
    } else {
      tempcheck = tempcheck.filter((ck) => ck.name !== value);
    }

    let str = "";
    for (var i = 0; i < tempcheck.length; i++) {
      str += tempcheck[i].name + ",";
    }
    str = str.replace(/,\s*$/, "");
    setCheckk(tempcheck);
    props.handleAchange(str);
  };

  return (
    <>
      {testJson.map((tst, i) => (
        <div key={i + 234}>
          <div className="form-check">
            <label className="form-check-label" for={tst.val}>
              <input
                type="checkbox"
                className="form-check-input"
                value={tst.val}
                onChange={(e) => handleChange(e)}
              />
              {tst.val}
            </label>
          </div>
        </div>
      ))}
    </>
  );
}

export default Tests;
